import moment from "moment";
import React, { useState } from "react";
import { BiCopy, BiTrashAlt } from "react-icons/bi";
import { GoCircle, GoPlusCircle } from "react-icons/go";
import { HiDocument, HiDocumentAdd, HiDocumentDuplicate } from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import { useCustomContextMenu } from "src/components/UseContextMenu";
import { useStudent } from "src/contexts/student";
import {
  useCreateAssessment,
  useDuplicateAssessment,
} from "src/modules/assessment/caching/queries";
import { AssessmentClass } from "src/modules/fithub-shared/anthropometry/assessment";
import { twMerge } from "tailwind-merge";
import { useAssessmentContext } from "../context/assessmentContext";
import { CreateButton } from "./styles";

// import { Container } from './styles';
import "./styles.css";
interface ListProps {
  selected: string;
  onSetSelected(id: string): void;
  handleDelete(): void;
  Reload(): void;
  list: AssessmentClass[] | undefined;
  addComparision(id: string): void;
  removeComparision(id: string): void;
  comparisionList: string[];
}

const AssessmentList: React.FC<ListProps> = (props) => {
  const [compare, setCompare] = useState(false);

  const student = useStudent().student;

  const assessmentC = useAssessmentContext();

  const create = useCreateAssessment(student?.id);

  const duplicate = useDuplicateAssessment(props.selected, student?.id);

  const { showContextMenu, closeContextMenu, ContextMenu } =
    useCustomContextMenu();

  function Delete() {
    props.handleDelete();
    closeContextMenu();
  }

  function Duplicate() {
    duplicate.mutateAsync().then(() => {
      closeContextMenu();
      props.Reload();
    });
  }

  const contextItems = [
    {
      title: "Duplicar",
      icon: BiCopy,
      action: Duplicate,
    },
    { title: "Deletar", icon: BiTrashAlt, action: Delete },
  ];

  async function CreateAssessment() {
    create.mutateAsync();
    props.Reload;
  }

  const GetDateDescription = (date: Date) => {
    //alert(date)
    return moment(date).format("dddd, D [de] MMMM, YYYY - HH:mm");
  };

  //TODO: Ver o que fazer com esta função
  //const dialog = useDialog();

  /*function showSaveDialog() {
    dialog.openDialog(
      "Aviso",
      "A avaliação atual contém modificações não salvas! Gostaria de salvar antes de sair?",
      assessmentC.save,
      "Salvar",
    );
  }*/

  function onSelect(id: string) {
    if (!assessmentC.saved && props.selected) {
      alert("Salve a avaliação atual antes de acessar uma diferente!");
      return;
    }

    props.Reload();
    if (props.selected !== id) props.onSetSelected(id);
  }

  const navigate = useNavigate();

  function Compare() {
    if (!assessmentC.saved && props.selected) {
      alert("Salve a avaliação atual antes de acessar uma diferente!");
      return;
    }

    props.Reload();
    setCompare(!compare);
    /*navigate("/beta-assessment");*/
  }

  return (
    <div className="flex w-full flex-1 flex-col overflow-hidden p-2">
      <ContextMenu />

      {/* Cabeçalho fixo com botões */}
      <div className="mb-2 flex w-full gap-2">
        <CreateButton
          className="bg-zinc-400 text-sm font-semibold uppercase text-zinc-700 dark:bg-zinc-700 dark:text-white"
          onClick={CreateAssessment}
        >
          <HiDocumentAdd />
          Criar Avaliação
        </CreateButton>

        <CreateButton
          className={twMerge(
            "bg-zinc-400 text-sm font-semibold uppercase text-zinc-700 dark:bg-zinc-700 dark:text-white",
            compare && "border-2 border-zinc-500",
          )}
          onClick={Compare}
        >
          <HiDocumentDuplicate />
          Comparar Avaliações
        </CreateButton>
      </div>

      {/* Lista scrollável */}
      <div className="scrollbar-hide flex flex-col divide-y divide-gray-300 overflow-y-auto rounded-md border border-gray-300 dark:divide-zinc-700 dark:border-zinc-700">
        {props.list &&
          props.list.map((element, index) => (
            <div
              key={element.id}
              onContextMenu={(e) => showContextMenu(e, contextItems)}
              className={twMerge(
                element.id === props.selected && "bg-zinc-200 dark:bg-zinc-700",
                "flex items-center px-3 py-2 text-black dark:text-white",
              )}
            >
              <HiDocument size={22} color="#444" />

              <div
                className="flex-1 cursor-pointer flex-col px-4"
                onClick={() => onSelect(element.id)}
                onAuxClick={() => onSelect(element.id)}
              >
                <h4>{element.title}</h4>
                <p className="text-xs">
                  {GetDateDescription(element.created_at)}
                </p>
              </div>

              {compare && (
                <div
                  onClick={() => {
                    const isSelected = props.comparisionList.includes(
                      element.id,
                    );
                    if (isSelected) props.removeComparision(element.id);
                    else props.addComparision(element.id);
                  }}
                  className="cursor-pointer text-zinc-600 transition-all dark:text-white"
                >
                  {props.comparisionList.includes(element.id) ? (
                    <div className="pointer-events-none relative flex h-6 w-6 items-center justify-center">
                      <GoCircle
                        size={24}
                        className="text-zinc-600 dark:text-white"
                      />
                      <span className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 pb-0.5 text-[15px] font-semibold">
                        {props.comparisionList.indexOf(element.id) + 1}
                      </span>
                    </div>
                  ) : (
                    <GoPlusCircle size={24} className="text-zinc-500" />
                  )}
                </div>
              )}
            </div>
          ))}
      </div>
    </div>
  );
};

export default AssessmentList;
